import { lookSolver, twoBoneSolver } from '../ossos.min.js';

export default function limbCompose(target, chain, pose, debug) {
  // Resolve the target to the current pose data
  target.resolveTarget(chain, pose);

  // Align the the root bone to the target direction
  lookSolver(target, chain, pose);

  // If the target is to far away, straighten the limb
  // Else bend the mid joint using the idea of triangles
  if (target.dist >= chain.len) chain.resetPoseLocal(pose, 1, 1);
  else twoBoneSolver(target, chain, pose, debug);
}
